import { module } from 'stereomodularjs';

import gsap from 'gsap';
import {
    ScrollTrigger
} from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // i want to make a array of all the section with the class o-section-gutenberg or wp.block-group if there a ID to the section and do nothing if there no ID on the section
        this.sections = gsap.utils.toArray('.o-section-gutenberg[id], .wp-block-group[id], .js-nav-anchor[id], .nav-anchor-inner-group[id]');
        // this.sections = gsap.utils.toArray('.o-section-gutenberg, .wp-block-group, .js-nav-anchor');
        this.nav = gsap.utils.toArray('.c-menu-anchors__link');

        if (this.sections.length > 0) {
            this.sections.forEach((section, i) => {
                //get the section id if there is any
                const id = section.getAttribute('id');
                
                //get the nav link into the nav-item with the same data-anchor value of the ID 
                const navLink = this.nav.find(link => link.getAttribute('data-anchor') === id);
                
                
                
                ScrollTrigger.create({
                    trigger: section,
                    start: () => `top 31%`,
                    end: () => `bottom 19%`,
                    markers: false,
                    onEnter: () => {
                        //add active class to the nav link that the data-anchor corresponding to the id of the section and do nothing if there is no nav link corresponding to the section
                        if (navLink) {
                            navLink.closest('.c-menu-anchors__item').classList.add('-is-active');
                        }
                    },
                    onLeave: () => {
                        if (navLink) {
                            navLink.closest('.c-menu-anchors__item').classList.remove('-is-active');
                        }
                    },
                    onEnterBack: () => {
                        if (navLink) {
                            navLink.closest('.c-menu-anchors__item').classList.add('-is-active');
                        }
                    },
                    onLeaveBack: () => {
                        if (navLink) {
                            navLink.closest('.c-menu-anchors__item').classList.remove('-is-active');
                        }
                    }
                });
            });
            window.dispatchEvent(new Event('resize'));
            const resize_ob = new ResizeObserver(() => {
                ScrollTrigger.refresh();
            });
            resize_ob.observe(document.querySelector('body'));
        };
    }

    destroy() {
        super.destroy();
        const allScrollTrigger = ScrollTrigger.getAll();
        for (let i = 0; i < allScrollTrigger.length; i++) {
            allScrollTrigger[i].kill(true);
        }
    }
}